import { IOrder } from 'exchange-common'

export const userOpenOrders = (state: IOrder[] = [], action: any): IOrder[] => {
	switch (action.type) {
		case 'UserOpenOrders.List':
			return [
				...action.openOrders,
			]
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/userOpenOrders.ts